import { IconButton } from 'features/nekst-widgets';

export { IconType } from 'features/nekst-widgets';

export default IconButton;
